import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ViewOrientation = 'vertical' | 'horizontal'

interface WorkViewModeState {
  orientation: ViewOrientation
  setOrientation: (o: ViewOrientation) => void
  toggle: () => void
}

/**
 * Persisted UI preference for whether the Work timeline renders as stacked
 * rows (vertical) or kanban-style columns (horizontal). Persisted globally so
 * the choice carries between Tasks, Projects, and ProjectDetail surfaces.
 */
export const useWorkViewMode = create<WorkViewModeState>()(
  persist(
    (set) => ({
      orientation: 'vertical',
      setOrientation: (orientation) => set({ orientation }),
      toggle: () =>
        set((s) => ({ orientation: s.orientation === 'vertical' ? 'horizontal' : 'vertical' })),
    }),
    { name: 'work-view-mode' }
  )
)
